import store from '@/store'
import { ref } from '@vue/composition-api'
import { getData } from '@core/utils/http/general'

export const configTableUsuarios = () => {
  const tableColumns = [
    { key: 'id', sortable: true },
    { key: 'fullname', label: 'Campus Virtual', sortable: true },
    { key: 'email', label: 'Salon virtual Moodle', sortable: true },
  ]

  const configRequest = ref({
    wsType: 'wsmoodleadmin', //* WebService name
    wsParams: { action: 30, token: store.state.cuenta.session.token }, //* Request params
    filterGetter: 'salonesMoodle/filterUsuariosMoodle', //* Getter function to filter data
    methodpost: true,
  })
  return {
    tableColumns,
    configRequest,
  }
}
export const useUsuariosMoodleCatalogos = () => {
  const PlanEstudios = ref([])

  const PlanOptionsPromise = new Promise((resolve, reject) => {
    getData({ action: 1, token: store.state.cuenta.session.token }, 'wsplanEstudios')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          PlanEstudios.value = response.data.data
          resolve()
        } else reject(response.data.messag)
      })
      .catch(err => { reject(err) })
  })

  return {
    // Promise fetch options
    PlanOptionsPromise,
    // Options
    PlanEstudios,
  }
}
